import API from "..";

export default class BlendStatus {

  constructor({
    blendStatusName,
    isActive,
    displayOrder
}) 
    
  {
    this.blendStatusName = blendStatusName;
    this.isActive = isActive;
    this.displayOrder = displayOrder;
  }

  static async getAllBlendStatuses() {
    const api = await API();
    const { data } = await api.get(`/blendStatus`);
    if (data.result) {
        return data.result.map((d) => new BlendStatus(d));
    }
    else {
        return [];
    }
  }
}
